import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";

export type PopoverTriggerProps = ComponentProps<typeof PopoverPrimitive.Trigger>;

export const PopoverTrigger = (props: PopoverTriggerProps) => (
  <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
);
